<template>
  <section>
    <div class="container py-5">
      <div class="row justify-content-center">
        <!-- 選擇練習 -->
        <div class="col-12 col-md-6 col-lg-5 mb-4" v-if="isPracticeEnabled">
          <div class="module-card">
            <!-- @click="goToPractice" 暫時不開放練習題 -->
            <div class="module-card__icon">
              <i class="fa fa-check-circle"></i>
            </div>
            <h3 class="module-card__title">選擇練習</h3>
            <p class="module-card__description">
              進行選擇題練習與測驗
            </p>
            <button class="btn btn-primary btn-lg" disabled>
              敬請期待
            </button>
          </div>
        </div>

        <!-- 申論試卷 -->
        <div class="col-12 col-md-6 col-lg-5 mb-4">
          <div class="module-card" @click="goToEssayPapers">
            <div class="module-card__icon">
              <i class="fa fa-edit"></i>
            </div>
            <h3 class="module-card__title">申論試卷</h3>
            <p class="module-card__description">
              進行申論題作答與考試
            </p>
            <button class="btn btn-primary btn-lg">
              前往考試
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModuleSelection',
  data() {
    return {
      isPracticeEnabled: true,
      isLoading: false,
    };
  },
  mounted() {
    this.checkPracticeStatus();
  },
  methods: {
    // 檢查選擇練習狀態
    async checkPracticeStatus() {
      // 目前預設為啟用狀態
      this.isPracticeEnabled = true;

      // 若選擇練習被停用，自動導向申論試卷
      if (!this.isPracticeEnabled) {
        this.$router.push('/essayPapers');
      }
    },

    // 導航至選擇練習
    goToPractice() {
      this.$router.push('/practices');
    },

    // 導航至申論試卷
    goToEssayPapers() {
      this.$router.push('/essayPapers');
    },
  },
};
</script>

<style lang="scss" scoped>
.module-card {
  background: #f4f4f4;
  border-radius: 12px;
  padding: 40px 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border-color: #0096a4;
  }

  &__icon {
    font-size: 64px;
    color: #0096a4;
    margin-bottom: 24px;

    i {
      display: inline-block;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 12px;
  }

  &__description {
    font-size: 15px;
    color: #777777;
    margin-bottom: 24px;
    line-height: 1.6;
  }

  .btn {
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
}

// 手機版響應式樣式
@media (max-width: 768px) {
  .module-card {
    padding: 30px 20px;

    &__icon {
      font-size: 48px;
      margin-bottom: 16px;
    }

    &__title {
      font-size: 20px;
    }

    &__description {
      font-size: 14px;
      margin-bottom: 16px;
    }

    .btn {
      padding: 10px 24px;
      font-size: 15px;
    }
  }
}
</style>
